import { List } from "immutable";

import { composeSelector } from "seneca-common/utils/selectors/compose-selectors";

import { Word, WordId, Words } from "../../../models/state/words/Words";
import * as wordSelectors from "./word";

export function getWord(words: Words, wordId: WordId) {
  return words.get(wordId);
}

export const getWordId: (words: Words, wordId: WordId) => WordId | undefined =
  composeWordSelector(wordSelectors.getId);

export const getWordWord: (words: Words, wordId: WordId) => string | undefined =
  composeWordSelector(wordSelectors.getWord);

export const getWordDefinition: (
  words: Words,
  wordId: WordId
) => string | undefined = composeWordSelector(wordSelectors.getDefinition);

export const getWordModuleIds: (words: Words, wordId: WordId) => List<string> =
  composeWordSelector(wordSelectors.getModuleIds);

function composeWordSelector<T>(
  selector: (word: Word) => T
): (words: Words, wordId: WordId) => T {
  // @ts-ignore
  return composeSelector(getWord, selector);
}
